import React from "react";
import "./style.scss";
import { CircularProgress } from "@mui/material";
import { ReactComponent as Up } from "../../../../../assets/images/icon-up.svg";
import { ReactComponent as Down } from "../../../../../assets/images/icon-down.svg";
import { formatNumber } from "../../../../../services/utility/utils";
import { ReactComponent as CoinValue } from "../../../../../assets/images/icon-coin-bet.svg";
import { ReactComponent as Warning } from "../../../../../assets/images/warning.svg";
import { ReactComponent as Triangle } from "../../../../../assets/images/triangle.svg";
import { formatNumberForOdds } from "../../../../../utils/utils";

export default function ContentBetFixedOdds(props) {
  const {
    loadingConfirm,
    type,
    isBet,
    isSuccess,
    wager,
    isOddChange,
    onConfirm,
    onCancel,
    contest,
    oldOdd,
    lang,
    msgError,
    isError,
  } = props;

  const currentOdd =
    type === "below"
      ? contest?.whitelabelRektOdds || 0
      : contest?.whitelabelMoonOdds || 0;

  const isDown = currentOdd <= oldOdd;

  return (
    <div className={`wrap-card-loading-confirm ${type}-select`}>
      <div
        className={`wrap-content animate__animated  
          ${type && isBet && `animate__fadeIn animate-delay-0`}
          ${
            type &&
            !isBet &&
            `animate__fadeIn animate-delay-0 animate-duration-0`
          }
          ${!type && "animate__fadeOut "}`}
      >
        <div className="wrap-label-top">
          {loadingConfirm && !isSuccess && !isOddChange && (
            <div className="wrap-label-loading-bet">
              <CircularProgress
                size={18}
                className="circular-progress"
                style={{
                  color: "#050503",
                }}
              />
              <p className="label-placing">
                {lang?.placing_bet || "Placing Bet"}
              </p>
            </div>
          )}

          {isSuccess && (
            <div className="wrap-label-loading-bet">
              <p className="label-placing">
                {lang?.bet_confirmed || "Bet Confirmed!"}
              </p>
            </div>
          )}

          {(isError || isOddChange) && !isSuccess && (
            <div className="wrap-label-loading-bet">
              <Warning />{" "}
              {isOddChange ? (
                <p className="label-placing">
                  {lang?.odds_update || "Odds Update"}
                </p>
              ) : (
                <p className="label-placing">
                  {lang?.bet_unsuccessful || "Bet unsuccessful"}.
                </p>
              )}
            </div>
          )}
        </div>

        <div className="content content-fixedOdds">
          {type === "below" ? (
            <div
              className="wrap-icon-down"
              style={{
                opacity: isSuccess || isOddChange ? 0.25 : 1,
              }}
            >
              <Down />
            </div>
          ) : (
            <div
              className="wrap-icon-up"
              style={{
                opacity: isSuccess || isOddChange ? 0.25 : 1,
              }}
            >
              <Up />
            </div>
          )}

          {isSuccess && (
            <div className="wrap-content-confirmed">
              <p className="label-confirmed">
                {lang?.potential_payout || "Potential payout"}
              </p>
              <div className="wrap-value-confirmed">
                <span>$</span>
                <p className="value-confirmed">
                  {/* {formatNumber(Number(formatNumber(oldOdd, 2)) * wager, 2)} */}
                  {formatNumberForOdds(oldOdd * wager)}
                </p>
              </div>
            </div>
          )}

          {(isError || isOddChange) && !isSuccess && (
            <div className="wrap-content-odds-change">
              <p className="label-odd-change">
                {msgError ||
                  lang?.the_price_changed ||
                  "The price of your selection has changed"}
              </p>
              {isOddChange && (
                <div
                  className={`wrap-button-confirm ${
                    isOddChange && "wrap-button-confirm-odd-change"
                  }`}
                >
                  <div
                    className={`btn-confirm btn-confirm-${type}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onConfirm();
                    }}
                  >
                    {lang?.confirm_your_bet || "Confirm your Bet"}
                  </div>

                  <div
                    className="btn-cancel"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCancel();
                    }}
                  >
                    {lang?.cancel || "Cancel"}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {(!isError || (isError && isOddChange)) && <div className="wrap-content-bottom">
          <div className="content-bottom">
            <div
              className={`wrap-wager ${type === "below" && "wrap-wager-below"}`}
            >
              <CoinValue /> <span>${formatNumberForOdds(wager, true)}</span>
            </div>

            <div className="wrap-odds">
              <p className="label-odds">{lang?.odds || "Odds"}</p>
              {!isSuccess && isOddChange && (
                <p className="odds-old">{formatNumberForOdds(oldOdd)}</p>
              )}
              <p className="odds-value">
                {!isOddChange
                  ? formatNumberForOdds(oldOdd)
                  : formatNumberForOdds(currentOdd)}
              </p>
              {!isSuccess && isOddChange && (
                <div className={`${!isDown ? "new-odds-up" : ""}`}>
                  <Triangle />
                </div>
              )}
            </div>
          </div>
        </div>}
      </div>
    </div>
  );
}
